/* nutrive: confetti when the cart crosses the free-shipping threshold (watches the cart drawer bar) */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const done = () => { const b = document.querySelector('[data-nv-shipbar]'); return b ? b.classList.contains('is-done') : false; };
  const confetti = () => {
    if (reduce) return;
    const cols = ['#AD5D31', '#69744E', '#2E2017', '#D8A07A', '#F0E3D0'];
    for (let i = 0; i < 60; i++) {
      const c = document.createElement('i');
      c.className = 'nv-confetti';
      c.style.left = Math.random() * 100 + 'vw';
      c.style.background = cols[i % cols.length];
      document.body.appendChild(c);
      c.animate(
        [{ transform: 'translateY(0) rotate(0)' }, { transform: `translate(${(Math.random() - 0.5) * 200}px, ${innerHeight + 40}px) rotate(${Math.random() * 720}deg)` }],
        { duration: 2000 + Math.random() * 1400, delay: Math.random() * 300, easing: 'cubic-bezier(.2,.6,.4,1)' }
      ).onfinish = () => c.remove();
    }
  };
  const start = () => {
    let last = done();
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => { const now = done(); if (now && !last) confetti(); last = now; }, 120);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();